// SPDX-License-Identifier: GPL-3.0-or-later
// Copyright (C) 2026 Radiooooo

/**
 * Whether this browser expects a session: set when a sign-in completes,
 * cleared at the session boundary and when a boot restore is refused. The
 * page and the boot read it to fetch the frame and the Mapbox chunk before
 * the restore answers, which is right for a listener coming back and wrong
 * for a browser that was signed out or whose cookie lapsed; the stored
 * context used to stand in for it and outlived both.
 */
export const SESSION_MARKER_KEY = "rd.session";

type Storage = { getItem(key: string): string | null; setItem(key: string, value: string): void; removeItem(key: string): void };

export function expectsSession(storage: Storage | undefined): boolean {
    try {
        return Boolean(storage?.getItem(SESSION_MARKER_KEY));
    } catch {
        return false;
    }
}

export function rememberSession(storage: Storage | undefined): void {
    try {
        storage?.setItem(SESSION_MARKER_KEY, "1");
    } catch {
        // no storage: the next boot is a visitor's, which is the safe guess
    }
}

export function forgetSession(storage: Storage | undefined): void {
    try {
        storage?.removeItem(SESSION_MARKER_KEY);
    } catch {
        // nothing to forget
    }
}
